export const productsAuthPaths = ['reset-password/request', 'reset-password', 'create-password'];

export const productsAuthMetaTitleByPath: Record<string, string> = {
  'create-password': 'Create Your Password',
  'reset-password': 'Reset Your Password',
  'reset-password/request': 'Reset Your Password',
};
